import { render, staticRenderFns } from "./User4View.vue?vue&type=template&id=198124f2"
import script from "./User4View.vue?vue&type=script&lang=js"
export * from "./User4View.vue?vue&type=script&lang=js"
import style0 from "./User4View.vue?vue&type=style&index=0&id=198124f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports